import { ReadTradingHistoryRequestDto, ReadTradingHistoryResponseDto } from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'

export const fetchTradingHistory = async (
  { token, idSf, ...params }: { idSf: string } & ReadTradingHistoryRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadTradingHistoryResponseDto> => {
  const response = await axios.get<ReadTradingHistoryResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/trades-history/${idSf}`,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    },
  )

  return response.data
}
